<template>
  <section class="container">
    <div class="d-flex mb-2">
      <h3>Window Projects</h3>
    </div>

    <v-tabs color="blue" left>
      <v-tab
        style="background-color: #343a40; color: white;border-radius: 5px;"
      >
        Past
      </v-tab>
      <v-tab
        style="background-color: #343a40; color: white;margin-left:3px;border-radius: 5px;"
      >
        New
        <v-badge color="grey lighten-2 black--text" content="0" class="ml-3">
        </v-badge
      ></v-tab>
    </v-tabs>

    <v-row style="margin-top:5px">
      <v-col cols="4">
        <v-card elevation="2" outlined>
          <v-card-title style="display: block !important"
            >Pentalon Construction
            <v-btn
              color="indigo lighten-1"
              style="color:white;width: 50px;float:right;"
              class="mr-0 mb-2 pr-8"
              small
              ><span style="margin-left: 15px;">New</span>
            </v-btn>
          </v-card-title>
          <v-card-subtitle
            ><span style="margin-top:10px">Project:XYZ </span>
          </v-card-subtitle>
          <v-card-text
            style="margin-left:13px;height:70px !important;padding-bottom: 75px;"
          >
            <v-row> 1185 WEST LORI LANE</v-row>
            <v-row>KAMAS UT 84036</v-row>
            <v-row> 435-649-8477</v-row>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <div
            style="margin-left: 15px;
    padding-bottom: 28px;
    padding-top: 15px;"
          >
            <v-row>
              <p class="ml-1 mb-0" style="font-size:12px">
                <strong>Recieved:</strong>11/24/2
              </p>
            </v-row>
          </div>

          <v-card-actions style="height:40px;    padding-bottom: 25px;">
            <v-btn
              color="white darken-1"
              style="color:black;width: 90px;margin-left:5px"
              class="mr-2 mb-2 pr-8"
              small
              to="/dealer/projectdetail"
              ><span style="margin-left:15px">View RFQ </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card elevation="2" outlined>
          <v-card-title style="display: block !important"
            >Big-D Construction
            <v-btn
              color="indigo lighten-1"
              style="color:white;width: 50px;float:right;"
              class="mr-0 mb-2 pr-8"
              small
              ><span style="margin-left: 15px;">New</span>
            </v-btn>
          </v-card-title>
          <v-card-subtitle
            ><span style="margin-top:10px">Project: ZXF</span>
          </v-card-subtitle>
          <v-card-text
            style="margin-left:13px;height:70px !important;padding-bottom: 75px;"
          >
            <v-row> 1185 WEST LORI LANE</v-row>
            <v-row>KAMAS UT 84036</v-row>
            <v-row> 435-649-8477</v-row>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <div
            style="margin-left: 15px;
    padding-bottom: 28px;
    padding-top: 15px;"
          >
            <v-row>
              <p class="ml-1 mb-0" style="font-size:12px">
                <strong>Recieved:</strong>11/24/21
              </p>
            </v-row>
          </div>

          <v-card-actions style="height:40px;    padding-bottom: 25px;">
            <v-btn
              color="white darken-1"
              style="color:black;width: 90px;margin-left:5px"
              class="mr-2 mb-2 pr-8"
              small
              to="/dealer/projectdetail"
              ><span style="margin-left:15px">View RFQ </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card elevation="2" outlined>
          <v-card-title style="display: block !important"
            >Oakland Construction<v-btn
              color="indigo lighten-1"
              style="color:white;width: 50px;float:right;"
              class="mr-0 mb-2 pr-8"
              small
              ><span style="margin-left: 15px;">New</span>
            </v-btn>
          </v-card-title>
          <v-card-subtitle
            ><span style="margin-top:10px">Project:ACB Phase 1</span>
          </v-card-subtitle>
          <v-card-text
            style="margin-left:13px;height:70px !important;padding-bottom: 75px;"
          >
            <v-row> 1185 WEST LORI LANE</v-row>
            <v-row>KAMAS UT 84036</v-row>
            <v-row> 435-649-8477</v-row>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <div
            style="margin-left: 15px;
    padding-bottom: 28px;
    padding-top: 15px;"
          >
            <v-row>
              <p class="ml-1 mb-0" style="font-size:12px">
                <strong>Recieved:</strong>11/24/21
              </p>
            </v-row>
          </div>

          <v-card-actions style="height:40px;    padding-bottom: 25px;">
            <v-btn
              color="white darken-1"
              style="color:black;width: 90px;margin-left:5px"
              class="mr-2 mb-2 pr-8"
              small
              to="/dealer/projectdetail"
              ><span style="margin-left:15px">View RFQ </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-card elevation="2" outlined>
          <v-card-title style="display: block !important"
            >Oakland Construction<v-btn
              color="indigo lighten-1"
              style="color:white;width: 80px;float:right;"
              class="mr-0 mb-2 pr-8"
              small
              ><span style="margin-left: 15px;">Submitted</span>
            </v-btn>
          </v-card-title>

          <v-card-text
            style="margin-left:13px;height:70px !important;padding-bottom: 75px;"
          >
            <v-row> 1185 WEST LORI LANE</v-row>
            <v-row>KAMAS UT 84036</v-row>
            <v-row> 435-649-8477</v-row>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <div
            style="margin-left: 15px;
        padding-bottom: 28px;    padding-top: 15px;"
          >
            <v-row>
              <p class="ml-1 mb-0" style="font-size:12px">
                <strong>Recieved:</strong>11/24/21
              </p>
            </v-row>
          </div>

          <v-card-actions style="height:40px;    padding-bottom: 25px;">
            <v-btn
              color="white darken-1"
              style="color:black;width: 90px;margin-left:5px"
              class="mr-2 mb-2 pr-8"
              small
              ><span style="margin-left:15px">View Bid</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> PDF Viewer </v-card-title>

        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center align-center">
          <v-btn color="orange" small @click="dialog = false">
            Accept Bid
          </v-btn>
          <v-btn color="grey lighten-2" small @click="dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { scheduleApi } from "@/api";
export default {
  layout: "loginLayout",

  data() {
    return {
      searchText: "",
      all: false,
      sentrfq: false,
      recieved: false,
      pending: false,
      dialog: false,

      viewer_data: {
        createdBy: "rushabh@email.com",
        index: 7,
        isArchitect: "yes",
        projectName: "proj_one_24_jun_2021",
        scheduleName: "sch_one_24_jun_2021",
        versions: {
          URN:
            "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ",
          version_number: 1
        }
      }
    };
  },
  methods: {
    loadScheduleData() {
      scheduleApi
        .getScheduleItems({
          projectId,
          scheduleId,
          offset: 1,
          size: 1000,
          type: "windows",
          version: version
        })
        .then(({ data }) => {
          this.scheduleItems = data.data;
          this.$store.commit("changeSchedule", this.scheduleItems);
          console.log("state", this.$store.state.window.scheduleItems);
          //  this.$router.replace('/windows');
          console.log("schedules item data", data);
        });
    }
  },
  created() {
    console.log(this.questions);
    // this.loadScheduleData()
    this.$store.commit("changeItem", this.viewer_data);
  }
};
</script>

<style scoped>
.v-tab--active {
  color: inherit;
  background-color: #222020 !important;
}
</style>
